<template>
  <div class="choose-course">
    <Modal
      v-model="show"
      title="手动添加其他课时的材料结算"
      :footer-hide="true"
      width="80"
    >
      <div class="flex">
        <div class="left">
          <div class="search-line">
            <Input
              v-model="searchData.offerName"
              class="search-input"
              placeholder="请输入材料费名称"
              clearable
            ></Input>
            <div class="flex align-items" style="margin-right: 8px">
              {{ yearTermStr }}
            </div>

            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
              >搜索</Button
            >
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
            <div class="flex align-items" style="margin-left: 8px">
              <Checkbox v-model="searchData.isManyTimes" disabled
                >仅列出需分多次结算的材料费</Checkbox
              >
            </div>
          </div>
          <div class="table">
            <Table
              ref="selectionTable"
              border
              :columns="tableColumn"
              :data="tableList"
              :loading="tableLoading"
              :max-height="600"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            >
              <template slot-scope="{ row, index }" slot="startTimeList">
                <div @mouseover="handleMouseOver(index)">
                  <Select
                    v-model="selectRowTime[row.offerOrderId]['startTime']"
                    style="width: 100px"
                    :transfer="true"
                    :disabled="selectRowVal[row.offerOrderId]"
                    @on-change="onSelectStartTimeChange"
                  >
                    <Option
                      v-for="item in row.startTimeList"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select>
                </div>
              </template>
              <template slot-scope="{ row, index }" slot="endTimeList">
                <div @mouseover="handleMouseOver(index)">
                  <Select
                    v-model="selectRowTime[row.offerOrderId]['endTime']"
                    style="width: 100px"
                    :transfer="true"
                    :disabled="selectRowVal[row.offerOrderId]"
                    @on-change="onSelectEndTimeChange"
                  >
                    <Option
                      v-for="item in row.endTimeList"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select>
                </div>
              </template>
            </Table>
            <div class="page-main">
              <Page
                :total="pageInfo.total"
                show-total
                :current="pageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
                :page-size-opts="pageSizeOpts"
                @on-page-size-change="onPageSizeChange"
              ></Page>
            </div>
            <!-- <div class="iconTips">
              <Icon
                type="md-alert"
                size="16"
                color="#ff9900"
                style="padding-right: 10px"
              ></Icon
              >商品选择范围不含圈定报名范围、预报名的课程商品
            </div> -->
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectMaterialList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectMaterialList"
              height="550"
              ><template slot="action" slot-scope="{ row, index }">
                <Button
                  type="error"
                  size="small"
                  @click="handleRemove(row, index)"
                  >删除</Button
                >
              </template></Table
            >
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button style="margin-right: 16px" @click="handleCancleBtn"
          >取消</Button
        >
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import platformApi from '@/request/eduCenter/platform.js'
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {


  },
  props: {
    yearTermStr: {
      type: String,
      default: ''
    },
    termCode: {
      type: [String, Number],
      default: ''
    },
    yearCode: {
      type: [String, Number],
      default: ''
    },
    orgId: {
      type: String,
      default: ''
    },
    beginTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      searchData: {
        offerName: '',
        isManyTimes: true

      },
      pageSizeOpts: [10, 20, 50, 100], //每页条数
      selectMaterialList: [], // 选中的课程
      rightColumns: [{
        title: '材料费名称',
        key: 'materialName'
      },
      {
        title: '已选结算课时(可结算)',
        key: 'withholdTimes'
      },
      {
        title: '已选结算金额(可结算)(元)',
        key: 'withholdAmount'
      },
      {
        title: '操作',
        slot: 'action',
        width: 100,
        align: 'center'
      }],

      tableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '材料费名称',
          key: 'materialName'
        }, {
          title: '关联课程商品',
          key: 'offerName'
        }
        , {
          title: '材料费价格(元)',
          key: 'offerFee'
        }
        , {
          title: '材料费结算方式(分几课时结算)',
          key: 'totalTimes'
        }
        , {
          title: '结算开始课时',
          slot: 'startTimeList',
        }, {
          title: '结算结束课时',
          slot: 'endTimeList',
        }
      ], // 

      tableList: [], // 
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false,
      selectRowVal: {

      },
      selectRowTime: {

      }, // 选中的开始课时、结束课时
      selectIndex: -1
    };
  },
  computed: {

  },
  created() { },
  mounted() { },
  methods: {
    init() {
      this.pageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      // this.selectRowTime = {}
      // this.selectRowVal = {}
      this.tableList = [];
      this.getMaterialsList();
    },
    open(materialList) {
      this.show = true;
      this.selectMaterialList = materialList;
      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 提交
    handleSureBtn() {
      // if (this.selectMaterialList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      this.selectMaterialList.forEach(item => {
        item.startTime = this.selectRowTime[item.offerOrderId]['startTime']
        item.endTime = this.selectRowTime[item.offerOrderId]['endTime']
      })
      this.show = false;
      this.$emit('on-finish', this.selectMaterialList);
    },

    async batchMaterialWithholdCompute(info) {
      return new Promise(async (resolve, reject) => {
        let res = await orderCenterApi.batchMaterialWithholdCompute(info)
        if (res.status == 200) {
          resolve(res.message)
        }
      })
    },
    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getMaterialsList();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getMaterialsList();
    },
    // 
    async getMaterialsList() {
      const params = {
        offerName: this.searchData.offerName,
        isManyTimes: this.searchData.isManyTimes ? 1 : 0,
        yearCode: this.yearCode,
        termCode: this.termCode,
        orgId: this.orgId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        beginTime: this.beginTime,
        endTime: this.endTime
      };
      // const paramsTrue = Object.assign(params);
      // let res;
      //
      this.tableLoading = true;

      let res = await orderCenterApi.getSettleMaterials(params);

      this.tableLoading = false;
      if (res.status === 200) {
        this.tableList = res.message.list.map(item => {
          // item.classTimeShow = dealTimeList(item);
          item.offerFee = (item.offerFee / 100).toFixed(2)
          // item.startTime = 2
          // item.endTime = 2
          item.startTimeList = []
          item.endTimeList = []
          let len = item.totalTimes - item.settleTimes - item.refundTimes,
            sFlag = item.settleTimes + item.refundTimes + 1
          for (let k = sFlag; k <= item.totalTimes; k++) {
            item.startTimeList.push(k)
            item.endTimeList.push(k)
          }
          if (!this.selectRowTime[item.offerOrderId]) {
            this.selectRowTime[item.offerOrderId] = {
              startTime: sFlag,
              endTime: ''
            }
          }


          // item.startTime = sFlag
          // item.endTime = ''
          item.id = item.offerOrderId;

          return item;
        });
        this.pageInfo.total = Number(res.message.total);
        this.handleMaterialList();
      }
    },
    handleGetSearchValue() {
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
      this.getMaterialsList();
    },
    handleResetSearch() {
      this.searchData.offerName = ''
      this.$nextTick(() => {
        this.handleGetSearchValue()
      })
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectMaterialList.findIndex(item => {
        return item.offerOrderId == row.offerOrderId;
      });
      if (key != -1) {
        this.selectMaterialList.splice(key, 1);
      }
      this.$set(this.selectRowVal, row.offerOrderId, false)
      this.setSelectListMWValue()
    },
    onSelectStartTimeChange() {
      // this.$nextTick(() => {
      //   this.$refs.selectionTable.toggleSelect(this.selectIndex);
      // })
    },
    onSelectEndTimeChange() {
      // this.$nextTick(() => {
      //   this.$refs.selectionTable.toggleSelect(this.selectIndex);
      // })
    },
    onSelectAll(selection) {

      for (let k = 0, len = selection.length; k < len; k++) {
        if (!this.checkSelectRow(selection[k])) {
          this.cancelSelectAll(selection)

          break
        }
        this.onSelect(selection, selection[k]);
      }
      // selection.forEach(item => {
      //   this.onSelect(selection, item);
      // });
    },
    cancelSelectAll(selection) {
      for (let k = 0, len = selection.length; k < len; k++) {
        this.rowCheckedToggleSelect(selection[k].offerOrderId)
      }

    },
    onSelectAllCancel(selection) {
      this.tableList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row) {

      if (!this.checkSelectRow(row)) {
        this.rowCheckedToggleSelect(row.offerOrderId)
        return null
      }
      const key = this.selectMaterialList.findIndex(item => {
        return item.offerOrderId == row.offerOrderId;
      });
      if (key == -1) {
        this.selectMaterialList.push(row);
      }

      this.setSelectListMWValue()
      this.$set(this.selectRowVal, row.offerOrderId, true)
      // this.batchMaterialWithholdCompute([{
      //   offerOrderId: '871427215504486401',
      //   withholdTimes: 3
      // }])
    },
    async setSelectListMWValue() {
      let arr = this.selectMaterialList.map((item) => { return { offerOrderId: item.offerOrderId, withholdTimes: (this.selectRowTime[item.offerOrderId]['endTime'] - this.selectRowTime[item.offerOrderId]['startTime'] + 1) } })
      let res = await this.batchMaterialWithholdCompute(arr)
      this.selectMaterialList.forEach(item => {
        let key = res.findIndex(item_1 => { return item_1.offerOrderId == item.offerOrderId })
        if (key != -1) {
          item.withholdTimes = res[key]['withholdTimes']
          item.withholdAmount = res[key]['withholdAmount'] ? (Number(res[key]['withholdAmount']) / 100).toFixed(2) : 0
        }
      })
      this.selectMaterialList = Object.assign([], this.selectMaterialList)
    },
    // 表格项非选中
    rowCheckedToggleSelect(offerOrderId) {
      let key = this.tableList.findIndex(item => { return item.offerOrderId == offerOrderId })
      if (key != -1) {
        this.$nextTick(() => {
          this.$refs.selectionTable.toggleSelect(key);
        })
      }
    },
    checkSelectRow(row) {

      if (!this.selectRowTime[row.offerOrderId]['startTime']) {
        this.$Message.warning('请选择结算开始课时！');
        return false
      }
      if (!this.selectRowTime[row.offerOrderId]['endTime']) {
        this.$Message.warning('请选择结算结束课时！');
        return false
      }
      if (this.selectRowTime[row.offerOrderId]['startTime'] > this.selectRowTime[row.offerOrderId]['endTime']) {
        this.$Message.warning('结算开始课时 不能大于 结算结束课时');
        return false
      }
      return true
    },
    // 
    handleMouseOver(index) {
      this.selectIndex = index
    },
    // 删除
    handleRemove(row, index) {
      this.selectMaterialList.splice(index, 1);
      this.handleMaterialList();
    },
    // 处理列表选中效果
    handleMaterialList() {
      this.selectRowVal = {}
      this.tableList.forEach(item => {
        item._checked = false;
        const key = this.selectMaterialList.findIndex(item_1 => {
          return item_1.offerOrderId == item.offerOrderId;
        });
        if (key != -1) {
          item._checked = true;
          if (!this.selectRowTime[item.offerOrderId]) {
            this.selectRowTime[item.offerOrderId]['startTime'] = this.selectMaterialList[key]['startTime']
            this.selectRowTime[item.offerOrderId]['endTime'] = this.selectMaterialList[key]['endTime']
          }
          // item.startTime = this.selectMaterialList[key]['startTime']
          // item.endTime = this.selectMaterialList[key]['endTime']
          this.$set(this.selectRowVal, item.offerOrderId, true)
        } else {
          this.$set(this.selectRowVal, item.offerOrderId, false)

        }
      });
      this.tableList = Object.assign([], this.tableList);
    },
  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  height: 30px;
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 60%;
    margin-right: 20px;
  }
  .right {
    width: 38%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
